import { getUUID } from 'utils/uuid';

import SecureTokenStore from './secureTokenStore';
import {
  DEVICE_UUID_KEY,
  KEEP_ME_SIGNED_IN_KEY,
  SECURE_TOKEN_STORAGE_KEY,
} from './secureTokenStore.constants';

const secureTokenStore = new SecureTokenStore();

export const hydrateSecureTokenStore = () =>
  secureTokenStore.hydrate([SECURE_TOKEN_STORAGE_KEY, KEEP_ME_SIGNED_IN_KEY, DEVICE_UUID_KEY]);

export const getKeepMeSignedIn = () => secureTokenStore.getItem(KEEP_ME_SIGNED_IN_KEY) === 'true';

export const setKeepMeSignedIn = value =>
  secureTokenStore.setItem(KEEP_ME_SIGNED_IN_KEY, value ? 'true' : 'false', false);

export const getDeviceUuid = () => {
  const existingUuid = secureTokenStore.getItem(DEVICE_UUID_KEY);

  if (existingUuid) {
    return existingUuid;
  }

  // Never mint a device uuid before the secure store has hydrated from the keychain. A read that lands
  // mid-hydration (e.g. a native reload storm re-running boot before hydrateSecureTokenStore() settles)
  // sees an empty in-memory cache; minting here would fabricate + persist a throwaway uuid, clobbering
  // the real keychain value. That silent rotation is the SOURCE of duplicate VoIP pushes — each rotated
  // uuid leaves a stale "{oldUuid}:voip" Notification Hub installation carrying the same live PushKit
  // token, so one inbound call fans out to several PushKit deliveries (DEV-4332). Only mint once
  // hydration has completed and confirmed the keychain genuinely holds no uuid (a true fresh install).
  if (!secureTokenStore.isHydrated) {
    return null;
  }

  const deviceUuid = getUUID();
  secureTokenStore.setItem(DEVICE_UUID_KEY, deviceUuid, false);

  return deviceUuid;
};

export default secureTokenStore;
